import { Controller } from "@hotwired/stimulus"

// Postęp wysyłki zawiadomień: odpytuje `url-value` (JSON z DataBreachController#progress), dopóki status
// jest taki jak przy renderze (`status-value`: scheduled albo running), i przeładowuje stronę, gdy się
// zmieni — scheduled → running pokazuje pasek, running → finished stan końcowy (licznik w PDF, zgłoszenie).
export default class extends Controller {
  static targets = ["bar", "done", "failed"]
  static values = { url: String, interval: { type: Number, default: 3000 }, status: String }

  connect() {
    this.connected = true
    if (["scheduled", "running"].includes(this.statusValue)) this.schedule()
  }

  // Zapytanie w locie po nawigacji Turbo nie może przeładować strony, na którą przeszedł użytkownik.
  disconnect() {
    this.connected = false
    clearTimeout(this.timer)
    if (this.abortController) this.abortController.abort()
  }

  schedule() {
    this.timer = setTimeout(() => this.poll(), this.intervalValue)
  }

  async poll() {
    this.abortController = new AbortController()
    try {
      const response = await fetch(this.urlValue, { headers: { Accept: "application/json" }, signal: this.abortController.signal })
      if (!this.connected) return
      if (!response.ok) return this.schedule()

      const data = await response.json()
      if (!this.connected) return

      this.render(data)
      if (data.status === this.statusValue) return this.schedule()

      if (window.Turbo) window.Turbo.visit(window.location.href, { action: "replace" })
      else window.location.reload()
    } catch {
      if (this.connected) this.schedule()
    }
  }

  render(data) {
    if (this.hasBarTarget) this.barTarget.style.width = `${data.percent}%`
    if (this.hasDoneTarget) this.doneTarget.textContent = data.sent_count + data.failed_count
    if (this.hasFailedTarget) this.failedTarget.textContent = data.failed_count
  }
}
